import { UtilService } from 'src/app/service/util';
import { HttpClient } from '@angular/common/http';
import { TesInteligente } from './../interface/tes-inteligente';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TesInteligenteService {
  url = `${environment.urlApiProtheus}/wsrtesinteligente`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) { }

  getTipoOperacao(CFMTIPO: string, CFMPRODUTO: string, CTIPOPESSOA: string, CFMCODLOJA: string): Observable<TesInteligente> {
    return this.httpClient.get<TesInteligente>(`${this.url}/${CFMTIPO}/${CFMPRODUTO}/${CTIPOPESSOA}/${CFMCODLOJA}`, this.utilService.filtrosHttpOptions());
  }
}
